import { render, staticRenderFns } from "./MonthlyEPFHLB.vue?vue&type=template&id=2a1536c3&scoped=true"
import script from "./MonthlyEPFHLB.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFHLB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1536c3",
  null
  
)

export default component.exports